import { Autocomplete } from 'components';
import React, { useEffect, useState } from 'react';
import OrganizationServices from 'services/OrganizationServices';


/**
 * AutocompleteField - Themed, reusable autocomplete component with validation, using TextValidator as input.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */

const SugORGs = ({
    name,
    label,
    value,
    onChange,
    filter,
    options,                  
    required = false,
    validators = [],
    errorMessages = [],
}) => {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({ ...filter, search: null, status: 'Active' });

    useEffect(() => {
        if (options) return;    
        const fetchData = async () => {
            try {
                const res = await OrganizationServices.getAll({ ...filters });
                setData(
                    res?.data?.view?.data ||
                    res?.data?.organizations?.data ||
                    res?.data?.data ||
                    []
                );
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [filters, options]);

    const resolvedOptions = options || data;  

    const resolvedValue = React.useMemo(() => {
        if (!value) return null;
        if (typeof value === 'object' && value.id) return value;
        return resolvedOptions.find((item) => item.id === value) || null;
    }, [value, resolvedOptions]);

    return (
        <div>
            <Autocomplete
                name={name}
                label={label}
                value={resolvedValue}
                onChange={(event, newValue) => {
                    if (onChange) onChange(event, newValue);
                }}
                options={resolvedOptions}
                getOptionLabel={(option) => option.name || ''}
                textInputOnChange={(e) => {
                    if (!options) {                    
                        setFilters({ ...filters, search: e.target.value });
                    }
                }}
                required={required}
                validators={validators}
                errorMessages={errorMessages}
            />
        </div>
    );
};
export default SugORGs ;
